import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appViewContainerHost]',
})
export class ViewContainerHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
